module.exports = __webpack_public_path__ + "static/media/walkthrough-text-bubble.b0393031.svg";